import React from 'react';
import {
  AcceptInvitationErrorView,
  AcceptInvitationFormView,
  AcceptInvitationLoadingView,
  AcceptInvitationSuccessView,
} from './AcceptInvitationPageViews';
import { useAcceptInvitationPage } from './useAcceptInvitationPage';

interface AcceptInvitationPageProps {
  isAdmin?: boolean;
}

export const AcceptInvitationPage: React.FC<AcceptInvitationPageProps> = () => {
  const {
    verificationData,
    loading,
    submitting,
    error,
    success,
    formData,
    formErrors,
    isExistingContact,
    handleInputChange,
    handleAccept,
    handleReject,
    goHome,
    isAcceptDisabled,
  } = useAcceptInvitationPage();

  if (loading) {
    return <AcceptInvitationLoadingView />;
  }

  if (success) {
    return <AcceptInvitationSuccessView onGoHome={goHome} />;
  }

  if (error && !verificationData?.invitation) {
    return <AcceptInvitationErrorView error={error} onGoHome={goHome} />;
  }

  if (!verificationData?.invitation) {
    return null;
  }

  return (
    <AcceptInvitationFormView
      invitation={verificationData.invitation}
      isExistingContact={isExistingContact}
      formData={formData}
      formErrors={formErrors}
      error={error}
      submitting={submitting}
      isAcceptDisabled={isAcceptDisabled}
      onInputChange={handleInputChange}
      onAccept={handleAccept}
      onReject={handleReject}
    />
  );
};

export default AcceptInvitationPage;
